<template>
  <div>
    <SpCardContent title="规则详情">
      <el-row>
        <el-col :span="12">
          <div class="common-border">
            <el-form
              label-width="100px"
              class="demo-ruleForm"
            >
              <el-form-item label="创建时间：">
                <div class="form-item-val">
                  {{ syncParmas.created_at }}
                </div>
              </el-form-item>
              <el-form-item label="任务名称：">
                <div class="form-item-val">
                  {{ syncParmas.rule_name }}
                </div>
              </el-form-item>
              <el-form-item label="执行群聊：">
                <div class="form-item-val">
                  <template v-if="chatList && chatList.length > 0">
                    {{ chatList[0].name }}...
                    <!-- <div
                      style="height: 40px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;width: 70%;display: inline-block;
"
                    >
                      <span
                        v-for="chat in chatList"
                        :key="chat.chat_id"
                        style="display:inline-block;width:auto"
                      > {{ chat.name }}， </span>
                    </div> -->
                    <el-button
                      type="text"
                      @click="handleLooksop"
                    >
                      查看
                    </el-button>
                  </template>
                  <template v-else>
                    暂无群聊
                  </template>
                </div>
              </el-form-item>
              <el-form-item label="是否开启：">
                <div class="form-item-val">
                  {{ syncParmas.is_active }}
                </div>
              </el-form-item>
            </el-form>
          </div>
        </el-col>
        <el-col
          :span="11"
          :offset="1"
        >
          <div class="common-border">
            <div class="header">
              数据统计
            </div>
            <div class="tongji-body">
              <div class="tongji-body__item">
                <p>{{ syncParmas.chat_num }}</p>
                <p>今日提醒群聊</p>
              </div>
              <div class="tongji-body__item">
                <p>{{ syncParmas.owner_num }}</p>
                <p>今日提醒群主数</p>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </SpCardContent>
    <SpCardContent>
      <div class="plane-box">
        <h4 class="title">
          共{{ timeRuleLen }}条推送
        </h4>
        <ul class="plane-box-list">
          <li
            v-for="(item, index) in timeRule"
            :key="index"
          >
            <h4 class="title">
              <template v-if="item.status === '1'">
                群添加规则后，{{ item.hour }}小时{{ item.min }}分后提醒执行
              </template>
              <template v-else-if="item.status === '2'">
                群添加规则后，{{ item.days }}天后 当日{{ item.time }}分后提醒执行
              </template>
            </h4>
            <div class="content">
              <p>任务名称：{{ item.task_title }}</p>
              <template v-if="item.subtask_list">
                <p>
                  任务目标：<span
                    v-for="(v, k) in item.subtask_list"
                    :key="k"
                  > {{ v }} ,</span>
                </p>
              </template>
            </div>
          </li>
        </ul>
      </div>
    </SpCardContent>
    <!-- 执行群聊 -->
    <MembershipSelect
      :sop-visible="sopVisible"
      :select-data="selectStoreData"
      :chat-data="chatList"
      :bind-chat="bindChat"
      @closeSopDialog="closeSopDialog"
      @getSopDetail="getSopDetail"
    />
  </div>
</template>

<script>
import { getSopDetail } from '@/api/membership/membershipsop'
import MembershipSelect from '../membership/comps/membershipSelect'

export default {
  components: {
    MembershipSelect
  },
  data () {
    return {
      sopVisible: false,
      selectStoreData: [],
      syncParmas: {
        created_at: '',
        rule_name: '',
        is_active: '',
        chat_num: 0,
        owner_num: 0
      },
      chatList: [],
      bindChat: [],
      timeRule: [],
      timeRuleLen: 0
    }
  },
  mounted () {
    // const sop_id = this.$route.query.id
    // if (sop_id) {

    // }
    this.getSopDetail()
  },
  methods: {
    //获取sop详情
    getSopDetail () {
      const { id } = this.$route.params
      getSopDetail(id).then((res) => {
        if (res) {
          console.log('res---->', res)
          this.syncParmas.created_at = res.created_at
          this.syncParmas.rule_name = res.rule_name
          this.syncParmas.is_active = res.is_active === 1 ? '开启' : '关闭'
          this.syncParmas.chat_num = res.chat_num
          this.syncParmas.owner_num = res.owner_num
          this.timeRule = res.send_content
          this.timeRuleLen = res.send_content.length
          ;(this.chatList = res.chat_list),
            (this.bindChat =
              res.chat_list &&
              res.chat_list.map((item) => {
                return item.chat_id
              }))
        }
        console.log('bindChat', this.bindChat)
      })
    },
    handleLooksop () {
      this.sopVisible = true
    },
    // 关闭门店对话框
    closeSopDialog () {
      this.sopVisible = false
    },
    chooseSop () {}
  }
}
</script>

<style lang="scss" scoped>
.el-main {
  background: #dddddd;
}
.el-form {
  padding: 8px 0;
}
.el-form-item {
  margin-bottom: 5px;
  .form-item-val {
    color: #333333;
  }
}
.el-form-item__label {
  color: #999999;
}
.common-border {
  border: 1px solid #f1f1f1;
  box-sizing: border-box;
  .header {
    font-size: 14px;
    padding: 15px 0 15px 20px;
    border-bottom: 1px solid #dddddd;
  }
  .tongji-body {
    border: 1px solid $primary_active;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100px;
    background: #f1f9ff;
    margin: 20px;

    &__item {
      flex: 1;
      text-align: center;
    }
  }
}
.plane-box {
  // margin-top: 20px;
  // border: 1px solid #f1f1f1;
  // padding: 20px;
  .title {
    font-size: 14px;
    color: #333333;
    font-weight: bold;
  }
  .plane-box-list {
    li {
      margin-top: 20px;
      .content {
        background: #f1f1f1;
        padding: 20px;
        border-radius: 5px;
        line-height: 24px;
        margin-top: 10px;
      }
    }
  }
}
</style>
